import React, { useState } from 'react';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import OrganisationDropdown from '../Shared/OrganisationDropdown/index.tsx';
import SearchableDropdown from '../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
import { CampaignList } from '../../interfaces/Flowbuilder.interface.ts';
import { FlowBuilderActions } from '../../Services/_actions/index.js';
import DynamicBreadcrumbs from '../Shared/Breadcrumb/index.tsx';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router';
import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CampaignDropdown from '../Shared/CampaignDropdown/index.tsx';

interface FormData {
  organisation_name: string;
  campaign_id: string;
  campaign_name: string;
  selectedCampaign: any;
  selectedOrganisation: any;
  urls: string[];
}

const WebScrapping = () => {
  const [formData, setFormData] = useState<FormData>({
    organisation_name: '',
    campaign_id: '',
    campaign_name: '',
    selectedCampaign: null,
    selectedOrganisation: null,
    urls: [''],
  });
  const actions = FlowBuilderActions();
  const [isloading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [validationErrors, setValidationErrors] = useState<{ organisation?: string }>({});
  const [campaignList, setCampaignList] = useState<CampaignList>({ pages: 0, list: [] });

  const onSelectOrganisation = (value: any) => {
    const organisationId = value?.id || '';
    setFormData((prev) => ({
      ...prev,
      selectedOrganisation: value,
      organisation_name: value?.name || '',
    }));
    // const updatedFilter = {
    //   ...filterForCamapign,
    //   organisationId,
    //   search: '',
    //   next_page: 1,
    // };
  };

  const onSelectCampaign = (value: any) => {
    setFormData((prev) => ({
      ...prev,
      selectedCampaign: value,
      campaign_id: value?.value || '',
      campaign_name: value?.label || '',
    }));
  };
  const breadcrumbsData = [
    {
      label: (
        <IconButton color="primary">
          <HomeIcon />
        </IconButton>
      ),
      onClick: () => navigate('/'),
    },
    { label: 'Tools', onClick: () => navigate('/r/tools') },
    { label: 'Web Scrapping' },
  ];

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
      <DynamicBreadcrumbs
        items={breadcrumbsData}
        onBreadcrumbClick={(e, item) => item?.onClick?.()}
      />
      <div className="p-2">
        {/* <Typography variant="h4">Web Scrapping Page</Typography> */}
        <Box sx={{ display: 'flex', gap: '16px', flexWrap: { sm: 'nowrap', xs: 'wrap' } }}>
          <OrganisationDropdown
            label={
              <Typography component="span">
                Organization <span style={{ color: 'red' }}>*</span>
              </Typography>
            }
            value={formData.selectedOrganisation || null}
            onChange={(value) => {
              onSelectOrganisation(value);
              setValidationErrors((prev) => ({ ...prev, organisation: '' }));
            }}
            error={!!validationErrors.organisation}
            errorMessage={validationErrors.organisation}
            sx={{ mb: 1, mt: '4px' }}
          />
          {formData?.selectedOrganisation && (
            // <SearchableDropdown
            //   label="Campaign"
            //   options={
            //     campaignList?.list?.length > 0
            //       ? campaignList?.list?.map((campaign) => ({
            //         ...campaign,
            //         label: campaign?.name || '',
            //         value: campaign?.proposal_id || '',
            //       }))
            //       : [{ label: 'No Campaign', value: '' }]
            //   }
            //   value={formData?.selectedCampaign || null}
            //   onSearch={handeSearchCampaign}
            //   onChange={onSelectCampaign}
            //   loading={isloading}
            //   sx={{ marginBottom: 1 , mt:'4px' }}
            //   fetchMoreOptions={campaignList?.has_next ? loadMoreOptions : undefined}
            //   getOptionDisabled={(option) => option.value === ''}
            // />
            <CampaignDropdown
              label="Campaign"
              value={formData?.selectedCampaign || null}
              onChange={onSelectCampaign}
              error={false}
              errorMessage=""
              disabled={false}
              sx={{ marginBottom: 1, mt: '4px' }}
              organisationId={formData?.selectedOrganisation?.organisation_id || ''}
            />
          )}

          {/* <TextField
            // label="Date (YYYY-MM-DD)"
            type="date"
            fullWidth
            value={formData.date}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, date: e.target.value }))
            }
            sx={{ marginBottom: 2 }}
            margin="dense"
            variant="outlined"
            size="small"
          /> */}

          {/* <TextField
            // label="Time (HH:MM)"
            type="time"
            fullWidth
            value={formData.time}
            onChange={(e) =>
              setFormData((prev) => ({ ...prev, time: e.target.value }))
            }
            sx={{ marginBottom: 2 }}
            margin="dense"
            variant="outlined"
            size="small"
          /> */}
          <Box sx={{ width: '100%', overflowY: 'auto', height: '150px' }}>
            {formData.urls.map((url, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                gap={1}
                mb={1}
                mt={1}
                width="100%"
              >
                <TextField
                  label={`URL ${index + 1}`}
                  fullWidth
                  value={url}
                  onChange={(e) => {
                    const updatedUrls = [...formData.urls];
                    updatedUrls[index] = e.target.value;
                    setFormData((prev) => ({ ...prev, urls: updatedUrls }));
                  }}
                  variant="outlined"
                  size="small"
                />
                {formData.urls.length > 1 && (
                  <IconButton
                    onClick={() => {
                      const updatedUrls = formData.urls.filter((_, i) => i !== index);
                      setFormData((prev) => ({ ...prev, urls: updatedUrls }));
                    }}
                    color="error"
                  >
                    <CloseIcon />
                  </IconButton>
                )}

                {index === formData.urls.length - 1 && (
                  <IconButton
                    onClick={() =>
                      setFormData((prev) => ({
                        ...prev,
                        urls: [...prev.urls, ''],
                      }))
                    }
                    sx={{ width: '30px', height: '30px', lineHeight: '1.8' }}
                    color="primary"
                  >
                    <span style={{ fontSize: '24px' }}>+</span>
                  </IconButton>
                )}
              </Box>
            ))}
          </Box>
        </Box>
        <Box display="flex" justifyContent="center" mt={3}>
          <Button variant="contained" color="primary">
            SCRAPE
          </Button>
        </Box>
      </div>
    </Box>
  );
};

export default WebScrapping;
